import { useMemo } from 'react'
import { hasProAccess, hasProPlusAccess } from '../lib/planTier'
import type { UserTierState } from '../lib/tier'

export function useFeatureGate(tier: UserTierState | null) {
  const plan = tier?.plan ?? 'free'
  const isPro = useMemo(() => hasProAccess(plan), [plan])
  const isProPlus = useMemo(() => hasProPlusAccess(plan), [plan])

  return {
    plan,
    isPro,
    isProPlus,
    /** Any paid plan (Pro or Pro+) */
    isPremium: isPro,
    canWearables: isPro,
    canPredictiveCoach: isPro,
    canLiveCoach: isPro,
    canBioCalibration: isPro,
    canCalendarSync: isProPlus,
    canWeeklyCalendarView: isProPlus,
    canMealSwap: isProPlus,
    canOptimizedShopping: isProPlus,
    showLiveCoachingBadge: isPro,
  }
}
